exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Select__select___2FZJu {\n  background: white;\n  border: 1px solid #8c9fed;\n  color: #8c9fed;\n  display: block;\n  height: 32px;\n}\n", ""]);

// exports
exports.locals = {
	"select": "Select__select___2FZJu"
};